/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Datetimevalue2Inputs */

const en_entity_datetimevalue2 = /** @type {(inputs: Entity_Datetimevalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date Time Value`)
};

const de_entity_datetimevalue2 = /** @type {(inputs: Entity_Datetimevalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum/Zeit-Wert`)
};

/**
* | output |
* | --- |
* | "Date Time Value" |
*
* @param {Entity_Datetimevalue2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_datetimevalue2 = /** @type {((inputs?: Entity_Datetimevalue2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Datetimevalue2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_datetimevalue2(inputs)
	return de_entity_datetimevalue2(inputs)
});
export { entity_datetimevalue2 as "entity_dateTimeValue" }